import { useEffect, useState } from 'react'

/**
 * Used for components which require a numerical size, such as
 * threat graph and other canvas components.
 * @param ref the ref of the element to measure
 * @returns the size of the element referenced by the ref
 */
export function useSize<T extends HTMLElement>(ref: React.RefObject<T>) {
  const [size, setSize] = useState({ width: 0, height: 0 })
  useEffect(() => {
    if (!ref.current) return
    const obs = new ResizeObserver(([entry]) => {
      const { width, height } = entry.contentRect
      setSize({ width: Math.floor(width), height: Math.floor(height) })
    })
    obs.observe(ref.current)
    return () => obs.disconnect()
  }, [ref])
  return size
}
